import { CreateSurveyResponseDTO } from '@/core/dto/psychosocial-report';
import type { CreateSurveyResponse } from '@/types/Psychosocial';

export class CreateSurveyMapper {
	constructor(private readonly data: CreateSurveyResponseDTO) {}

	toDomain(): CreateSurveyResponse {
		return {
			survey_link: this.data.survey_link,
			survey: this.data.survey,
			url: this.data.url
		};
	}
}
